import React from 'react'
import TableDetail from '../TableDetail/TableDetail'
import CreatedUser from '../Modules/User/CreatedUser'
import LearningContinuumInfo from '../Modules/LearningContinuum/LearningContinuumInfo'
import LearningContinuumBulkDeleted from '../Modules/LearningContinuum/LearningContinuumBulkDeleted'
import DRInfo from '../Modules/DevelopmentalRubric/DRInfo'
import ClassInfo from '../Modules/Classes/ClassInfo'
import ManyCreated from '../Modules/ManyCreated/ManyCreated'
import TableDetailPhotos from '../TableDetailPhotos/TableDetailPhotos'

const PreviewCreated = ({ detail = {}, moduleName = '', action = '' }) => {
  let children = <TableDetail detail={detail} />

  if (moduleName === 'custom role') {
    children = (
      <TableDetail
        detail={{
          _id: detail._id,
          name: detail.name,
          modules: detail.modules
        }}
      />
    )
  }

  if (moduleName.indexOf('user') > -1 && !['migrate', 'hard delete'].includes(action)) {
    children = <CreatedUser detail={detail} />
  }
  if (action === 'migrate') {
    children = <TableDetail detail={detail} />
  }

  if (moduleName === 'learning continuum' && Array.isArray(detail?.deleted)) {
    children = <LearningContinuumBulkDeleted detail={detail} />
  } else if (moduleName === 'learning continuum' && action !== 'migrate') {
    children = <LearningContinuumInfo detail={detail} />
  }

  if (
    moduleName === 'developmental rubric' &&
    ![
      'migrate',
      'created worked examples',
      'deleted worked examples',
      'created growth goals',
      'deleted growth goals',
      'created granular steps',
      'deleted granular steps',
      'created worked examples for granular step',
      'deleted worked examples for granular step'
    ].includes(action)
  ) {
    children = <DRInfo detail={detail} />
  }

  if (moduleName === 'class' && !['migrate', 'hard delete'].includes(action)) {
    children = <ClassInfo detail={detail} />
  }
  if (action === 'created many') {
    return <ManyCreated detail={detail} />
  }

  if (action === 'uploaded') {
    children = <TableDetailPhotos photos={detail.photos} />
  }

  return <div className='relative pt-4'>{children}</div>
}

export default PreviewCreated
